import { lazy } from "react";
import LazyRoute from "../components/Common/LazyRoute";
import ROUTES from "./ROUTES";

const InvoiceTableView = lazy(() => import("../components/Billing/ParentInvoiceView.jsx"));
const PromoCodeView = lazy(() => import("../components/Billing/Admin/View/PromoCode/ListOfPromoCode.jsx"));
const ReferralView = lazy(() => import("../components/Billing/Admin/View/Refferals/ListOfRefferals.jsx"));
const AffiliateRequestsView = lazy(() => import("../components/Billing/Admin/View/Refferals/AffiliateRequests.jsx"));

export default [
  { path: ROUTES.BILLING.INVOICES, element: <LazyRoute><InvoiceTableView /></LazyRoute> },
  { path: ROUTES.BILLING.PROMO, element: <LazyRoute><PromoCodeView /></LazyRoute> },
  { path: ROUTES.BILLING.REFERRALS, element: <LazyRoute><ReferralView /></LazyRoute> },
  { path: ROUTES.BILLING.AFFILIATE_REQUESTS, element: <LazyRoute><AffiliateRequestsView /></LazyRoute> },
];
